export const EVENT_DATE = new Date(2026, 10, 1);
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EVENTS = [
  { id: "100m", hi: "100 मीटर दौड़", en: "100 Meter Race" },
  { id: "800m", hi: "800 मीटर दौड़", en: "800 Meter Race" },
  { id: "long_jump", hi: "लॉन्ग जंप", en: "Long Jump" },
  { id: "traditional", hi: "अन्य पारंपरिक खेल", en: "Other Traditional Games" },
];

export const CLASSES = ["9th", "10th", "11th", "12th"];
export const DOB_MIN = "2007-01-01";
export const DOB_MAX = "2014-12-31";

export const slipLink = (id) => `${window.location.origin}/slip/${id}`;

export const playerMessage = (d) =>
  [
    "🏆 *ग्राम पाठशाला मानपुर — हरियाणा दिवस खेल 2026*",
    `✅ *${d.full_name}*, your registration has been successful! / आपका पंजीकरण सफल रहा।`,
    `🆔 *${d.registration_id}* | 🏃 ${d.events.map((id) => EVENTS.find((e) => e.id === id)?.hi || id).join(", ")}`,
    "📍 मानपुर स्टेडियम | 📅 1 नवंबर 2026 | ⏰ सुबह 6:00 बजे",
    "⚠️ सभी को समय पर आना अनिवार्य है, आधार कार्ड साथ लाएँ।",
    `🧾 पर्ची (Slip): ${slipLink(d.registration_id)}`,
    "💪 जीत का जज़्बा लेकर आओ — गाँव का नाम रोशन करो!",
  ].join("\n");

export const playerWaLink = (d) => `https://api.whatsapp.com/send?phone=91${d.mobile}&text=${encodeURIComponent(playerMessage(d))}`;

export const reminderMessage = (d) =>
  [
    "⏰ *रिमाइंडर — कल है खेल प्रतियोगिता!*",
    `🏆 ${d.full_name} (🆔 ${d.registration_id}), हरियाणा दिवस खेल 2026 कल है।`,
    "📅 1 नवंबर 2026 | ⏰ *सुबह 6:00 बजे रिपोर्टिंग*",
    "📍 मानपुर स्टेडियम, मानपुर",
    "🪪 आधार कार्ड + पर्ची साथ लाएँ, समय पर पहुँचें।",
    `🧾 ${slipLink(d.registration_id)}`,
    "🔥 पूरी ताक़त से दौड़ो — गाँव का गौरव बढ़ाओ!",
  ].join("\n");

export const waLink = (d, kind) =>
  `https://api.whatsapp.com/send?phone=91${d.mobile}&text=${encodeURIComponent(kind === "reminder" ? reminderMessage(d) : playerMessage(d))}`;

export const smsMessage = (d, kind) =>
  kind === "reminder"
    ? `रिमाइंडर: ${d.full_name} (ID ${d.registration_id}), हरियाणा दिवस खेल कल 1 नवंबर 2026, सुबह 6:00 बजे मानपुर स्टेडियम पहुँचें। आधार कार्ड व पर्ची लाएँ। पर्ची: ${slipLink(d.registration_id)} - ग्राम पाठशाला मानपुर`
    : `${d.full_name}, your registration is successful! ID ${d.registration_id}. खेल: 1 नवंबर 2026, सुबह 6:00 बजे, मानपुर स्टेडियम। समय पर आना अनिवार्य, आधार कार्ड लाएँ। पर्ची: ${slipLink(d.registration_id)} - ग्राम पाठशाला मानपुर`;

export const smsLink = (d, kind) => `sms:+91${d.mobile}?body=${encodeURIComponent(smsMessage(d, kind))}`;

export const ageOn = (dobStr, on) => {
  if (!dobStr) return null;
  const [y, m, d] = dobStr.split("-").map(Number);
  let a = on.getFullYear() - y;
  if (on.getMonth() + 1 < m || (on.getMonth() + 1 === m && on.getDate() < d)) a -= 1;
  return a;
};

export const cleanMobile = (v) => {
  let s = (v || "").replace(/[\s-]/g, "");
  if (s.startsWith("+91")) s = s.slice(3);
  else if (s.length === 12 && s.startsWith("91")) s = s.slice(2);
  else if (s.length === 11 && s.startsWith("0")) s = s.slice(1);
  return s;
};

const validMobile = (v) => /^[6-9]\d{9}$/.test(cleanMobile(v));
const MOBILE_ERR = "सही 10 अंकों का मोबाइल नंबर डालें (6-9 से शुरू) / Enter a valid 10-digit Indian mobile number";
const REQ = "यह जानकारी आवश्यक है / This field is required";

export const validate = (f) => {
  const e = {};
  if (f.full_name.trim().length < 2) e.full_name = REQ;
  if ((f.father_name || "").trim().length < 2) e.father_name = REQ;
  ["mobile", "parent_mobile", "emergency_contact"].forEach((k) => {
    if (!f[k].trim()) e[k] = REQ;
    else if (!validMobile(f[k])) e[k] = MOBILE_ERR;
  });
  if (!f.dob) e.dob = REQ;
  else if (f.dob < DOB_MIN || f.dob > DOB_MAX)
    e.dob = "जन्म तिथि 2007 से 2014 के बीच होनी चाहिए / Date of birth must be between 2007 and 2014";
  if (!CLASSES.includes(f.player_class)) e.player_class = "कक्षा चुनें (9वीं–12वीं) / Select class 9th–12th";
  if (f.school.trim().length < 2) e.school = REQ;
  if (!f.events.length) e.events = "कम से कम एक खेल चुनें / Select at least one event";
  if (!f.parent_consent) e.parent_consent = "अभिभावक की सहमति आवश्यक है / Parent consent is required";
  if (!f.rules_agreement) e.rules_agreement = "खेल नियमों से सहमति आवश्यक है / You must agree to the rules";
  return e;
};

export const apiError = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) return d.map((x) => (x.msg || "").replace(/^Value error, /, "")).join(" • ");
  return "सर्वर से संपर्क नहीं हो पाया, फिर कोशिश करें / Could not reach server, please try again";
};
